var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPintrest = function SvgPintrest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 0a8 8 0 0 0-3.211 15.328c-.023-.559-.004-1.23.139-1.837l1.029-4.36s-.255-.51-.255-1.265c0-1.186.687-2.071 1.543-2.071.727 0 1.079.546 1.079 1.201 0 .731-.467 1.825-.707 2.839-.2.848.426 1.541 1.263 1.541 1.516 0 2.537-1.947 2.537-4.254 0-1.753-1.181-3.066-3.329-3.066-2.427 0-3.939 1.81-3.939 3.832 0 .696.206 1.188.527 1.569.149.175.169.245.116.446-.039.147-.127.501-.163.642-.054.202-.218.275-.401.2C3.11 10.289 2.59 9.064 2.59 7.689c0-2.273 1.916-4.998 5.717-4.998 3.055 0 5.065 2.21 5.065 4.583 0 3.138-1.745 5.483-4.316 5.483-.864 0-1.677-.467-1.955-.998 0 0-.465 1.844-.563 2.199-.169.618-.502 1.234-.805 1.715A8.001 8.001 0 1 0 8 0"
  })));
};
export default SvgPintrest;